import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { MoonIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-[#faf6f0] to-[#f0eadd] pt-8 pb-12 px-4 md:px-6 lg:px-8" data-id="element-67">
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 opacity-10 text-[#1a2e4a]" data-id="element-68">
        <MoonIcon size={64} data-id="element-69" />
      </div>
      <div className="absolute top-40 left-10 opacity-5 text-[#c4956a]" data-id="element-70">
        <StarIcon size={32} data-id="element-71" />
      </div>
      <div className="absolute bottom-20 right-20 opacity-5 text-[#c4956a]" data-id="element-72">
        <StarIcon size={24} data-id="element-73" />
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-75">
          <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wider text-[#1a2e4a] uppercase bg-[#d4a0a0]/20 rounded-full" data-id="element-76">
            Para mamás de bebés de 0-12 semanas
          </span>

          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-[#1a2e4a] leading-tight mb-4" data-id="element-77">
            Tu bebé tarde‑noche: qué hacer cuando llora sin parar
          </h1>

          <p className="text-lg md:text-2xl text-[#5a5a5a] mb-6 font-serif italic" data-id="element-78">
            Calma en 20 minutos + rutina PM con un mapa «si pasa X → haz Y» (sin
            promesas mágicas, sin consejos vagos).
          </p>

          <div className="relative mx-auto mb-8 max-w-2xl shadow-2xl rounded-xl overflow-hidden border-4 border-white" data-id="element-79">
            <img src="https://cdn.magicpatterns.com/uploads/9gnreUTd3yiJLQvgxcNMEN/BEBE.png" alt="Tu bebé tarde-noche kit digital en varios dispositivos" className="w-full h-auto object-cover" data-id="element-80" />
          </div>

          <div className="max-w-2xl mx-auto text-left space-y-4 bg-white/60 backdrop-blur-sm p-5 md:p-8 rounded-2xl border border-[#d4a0a0]/20 shadow-sm" data-id="element-81">
            <h3 className="font-serif text-xl md:text-2xl text-[#1a2e4a] font-bold mb-3" data-id="element-82">
              Hay una hora del día que no perdona.
            </h3>

            <p className="text-base text-[#5a5a5a] leading-relaxed" data-id="element-83">
              Durante la mañana todavía te dices «vale, podemos». A media tarde
              intentas ir por delante: pañal, toma, paseo, un poco de luz
              natural… Pero cuando llega el final del día, algo cambia.
            </p>

            <p className="text-base text-[#5a5a5a] leading-relaxed" data-id="element-84">
              Tu bebé llora. Y llora distinto. Tú empiezas a probar cosas.
              Cambiar de brazo, de habitación, de postura, de plan. Y cuanto más
              pruebas, más parece que nada encaja.
            </p>

            <p className="text-base text-[#5a5a5a] leading-relaxed font-medium" data-id="element-85">
              Lo peor no es el llanto. Lo peor es el pensamiento que aparece
              siempre igual:
            </p>

            <blockquote className="border-l-4 border-[#c4956a] pl-4 italic text-[#1a2e4a] text-lg my-4" data-id="element-86">
              «¿Y si esto soy yo? ¿Y si no lo estoy haciendo bien?»
            </blockquote>

            <p className="text-base text-[#1a2e4a] font-bold" data-id="element-87">
              Este PDF existe para cortar ese bucle.
            </p>
          </div>

          <div className="mt-8" data-id="element-88">
            <a href="https://plenava.com/cart/52227852173659id1:1" target="_blank" rel="noopener noreferrer" data-id="element-89">
              <Button size="lg" className="w-full md:w-auto text-lg px-10 py-6" data-id="element-90">
                Quiero el kit (6,39€)
              </Button>
            </a>
            <p className="mt-3 text-sm text-[#5a5a5a]" data-id="element-91">
              <span className="line-through opacity-60" data-id="element-92">19€</span> →{' '}
              <span className="font-bold text-[#c4956a]" data-id="element-93">6,39€</span> · 60%
              descuento · Acceso inmediato
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}